<div class="bc-email-compose">
  <div class="bc-email-widget bc-work-item-theme theme-0">
    <div class="bc-layout-wrapper">
      <div class="col-xs-12 col-sm-12 bc-work-lane"
           [ngClass]="{ 'col-md-8 col-lg-8': isCMAndExpandedLayout() }">
        <div class="bc-panel-maxh">
          <work-widget-header
            [workItem]="workItem"
            [title]="'bcEmailCompose.composeTitle' | translate"
            class="bc-panel"></work-widget-header>

          <div class="bc-compose-panel bc-panel clearfix" [attr.data-automation-id]="'bc-compose-panel'">
            <app-auto-save [model]="compose" [storageKey]="emailComposeStorageKey"></app-auto-save>

            <app-email-outgoing-header [model]="compose"
                                       (onFromAddressChange)="changeSenderEmailAccount($event)"></app-email-outgoing-header>

            <app-alert-box *ngIf="isFocused()"
                           [editorMessages]="editorMessages.messages"
                           (closeHandler)="clearEditorMessage()"></app-alert-box>

            <div class="inactive-email-panel-footer" *ngIf="!isFocused()">
              <app-inactive-widget-footer [text]="compose.message"></app-inactive-widget-footer>
            </div>

            <div class="bc-editor-container" [ngClass]="{ 'has-attachment': !attachments.isEmpty() }">
              <a (click)="toggleCannedMessagePanel()" class="btn btn-borderless btn-cm" [attr.data-automation-id]="'canned-message-button'">
                <svg-icon icon="can-outline"></svg-icon>
                <span *ngIf="isExpandedMode()">
                  <span class="cm-label" *ngIf="!isCannedMessageVisible" translate="bcEmailCompose.showCannedMessagesButton"></span>
                  <span class="cm-label" *ngIf="isCannedMessageVisible" translate="bcEmailCompose.hideCannedMessagesButton"></span>
                </span>
              </a>

              <app-editor
                [editorInitSetting]="editorToolbarSettings"
                [workItemId]="workItem.id"
                [(editorContentModel)]="compose.message"
                [cannedMessageRequest]="cannedMessageRequest"
                (editorSetupDone)="onEditorSetupDone($event)">
              </app-editor>
            </div>

            <app-email-attachments
              *ngIf="isExpandedMode() && !attachments.isEmpty()"
              class="email-attachment-aligned-list"
              [attachments]="attachments.files"
              (deleteAction)="attachments.deleteAttachment($event)"></app-email-attachments>

            <div class="bc-footer-buttons clearfix" *ngIf="isExpandedMode()">
              <button (click)="sendEmail()" class="btn btn-dark bc-footer-button"
                      [attr.data-automation-id]="'compose-email-send-button'"
                      [disabled]="isSendEmailDenied()">
                <span translate="bcEmailCompose.sendMessageButton"></span>
              </button>

              <button (click)="cancelEmail()" class="btn btn-light bc-footer-button"
                      [attr.data-automation-id]="'compose-email-cancel-button'">
                <span translate="bcEmailCompose.cancelButton"></span>
              </button>

              <div ngfSelect
                   [(file)]="selectedFile"
                   (fileChange)="attachments.uploadFiles(selectedFile)"
                   class="btn bc-footer-button bc-attachment-button">
                <svg-icon icon="attachment"></svg-icon>
              </div>
            </div>

            <div class="more-actions" *ngIf="!isExpandedMode()" [ngClass]="{ 'open': isMoreActionsVisible }">
              <div class="email-footer-icon-container" *ngIf="!isMoreActionsVisible">
                <app-email-attachments
                  *ngIf="!attachments.isEmpty()"
                  class="email-attachment-aligned-list"
                  [attachments]="attachments.files"
                  (deleteAction)="attachments.deleteAttachment($event)"></app-email-attachments>
                <div ngfSelect
                     [(file)]="selectedFile"
                     (fileChange)="attachments.uploadFiles(selectedFile)"
                     class="btn bc-footer-button bc-attachment-button collapsed-email-footer-icon">
                  <svg-icon icon="attachment"></svg-icon>
                </div>

                <svg-icon icon="ellipsis" (click)="toggleMoreActions()" class="collapsed-email-footer-icon more-actions-icon"></svg-icon>
              </div>

              <app-email-compose-more-actions
                *ngIf="isMoreActionsVisible"
                [isSendButtonDisabled]="isSendEmailDenied()"
                (sendMessage)="sendEmail()"
                (cancelMessage)="cancelEmail()"
                (togglePanel)="toggleMoreActions()"></app-email-compose-more-actions>
            </div>
          </div>
        </div>
      </div>

      <div class="bc-layout-wrapper cm-lane-wrapper"
           *ngIf="isCannedMessagePanelVisible()"
           [ngClass]="{ 'col-xs-12 col-sm-12 col-md-4 col-lg-4 bc-middle-lane': isExpandedMode() }">
        <app-canned-message-panel
          [cannedMessageRequest]="cannedMessageRequest"
          [workItemId]="workItem.id"
          [isOpened]="isCannedMessagePanelOpen"
          [isExpanded]="isExpandedMode()"
          [isCannedMessagesTabActive]="isCannedMessagesTabActive"
          [isCustomTabActive]="isCustomTabActive">
        </app-canned-message-panel>
      </div>
    </div>
  </div>
</div>
